import { api } from '~/data/api'
import { IAircraftModel, IResourceScope } from '~/utils/types'

export interface IUpdateAircraftModelProps {
  aircraft_model_id?: string
  aircraft_model: IAircraftModel
}

export async function updateAircraftModel({
  aircraft_model_id,
  aircraft_model,
}: IUpdateAircraftModelProps) {
  const response = await api().put(`/aircraft_model/${aircraft_model_id}`, {
    ...aircraft_model,
    name: aircraft_model?.name?.toUpperCase() ?? '',
  })
  return response.data
}

export async function createAircraftModel(aircraft_model: IAircraftModel) {
  const response = await api().post(`/aircraft_model`, {
    ...aircraft_model,
    name: aircraft_model?.name?.toUpperCase() ?? '',
  })
  return response.data
}

export async function deleteAircraftModel(aircraft_model_id: string) {
  const response = await api().delete(`/aircraft_model/${aircraft_model_id}`)
  return response.data
}

export interface IUpdateAssetModelScope extends Omit<IResourceScope, 'asset_model'> {
  asset_model_id: string
}
export async function updateAssetModelScope(props: IUpdateAssetModelScope) {
  const response = await api().put(`/asset_model/${props.asset_model_id}/change_scope`, {
    new_scope: props.resource_scope,
    new_owner: props.owner,
  })

  return response
}

export async function activeAircraft(aircraft_id: string) {
  const response = await api().post(`/aircraft/${aircraft_id}/active`)
  return response.data
}

export async function listAircraftModels(): Promise<IAircraftModel[]> {
  const { data } = await api().get('/aircraft_model')
  return data.docs
}

export interface IVerifyName {
  manufacturer_id: string
  name: string
}
export interface IVerifyNameResponse extends IVerifyName {
  available: boolean
  existing_id: string | null
}
export async function verifyAssetModelName({
  name,
  manufacturer_id,
}: IVerifyName): Promise<IVerifyNameResponse> {
  return await (
    await api().post('/aircraft_model/verify_name', { name, manufacturer_id })
  ).data
}
